module.exports = __webpack_public_path__ + "static/GriegPageImg.bc7e28ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/posts/img/GriegPageImg.jpg
// module id = 1511
// module chunks = 178813192718937